import urljoin from 'url-join';
import UISettings from '../../../../utils/UISettings';

export const initDigitalDataTradeUpProducts = (tradeUpProducts) => {
  if (!('products' in window.digitalData)) {
    window.digitalData.products = [];
  }

  tradeUpProducts.forEach((product) => {
    window.digitalData.products.push({
      productID: product.productId,
      productSKU: product.productSku,
      productName: product.productTitle,
      imageUrl: product.productImgUrl,
      productUrl: product.productUrl,
      manufacturer: product.productBrand,
      inStock: true,
      wasPrice: null,
      wasPriceFrom: null,
      wasPriceTo: null,
      currentPrice: (product.productPrice / 100).toFixed(2),
      savingsPrice: 0,
      perMonthPrice: null,
      emailMeBack: false,
      stockStatus: 'In stock',
      hdEligible: false,
      cisEligible: false,
      pacEligible: false,
      downloadEligible: false,
      financingAvailable: false,
      bundlesAvailable: null,
      isForwardOrder: false,
      availabilityMessage: null,
      isPreOrder: false,
      isBundle: false,
      separateSellingPrice: null,
      mainProductWasPrice: null,
      mainProductWasPriceFrom: null,
      mainProductWasPriceTo: null,
      mainProductCurrentPrice: null,
      mainProductSaving: null,
      subItemNames: []
    });
  });
};

export const fetchTradeupProductsFromBackend = async (mainProductId) => {
  const storeApiUrl = UISettings.get('global.store_api_url');
  const url = urljoin(
    storeApiUrl.replace('/store/api', ''),
    '/ff/upselling/',
    `/trade-up/${mainProductId}`
  );
  let response;
  try {
    response = await (await fetch(url)).json();
  } catch (error) {
    return [];
  }
  return response && response.tradeUpProducts ? response.tradeUpProducts : [];
};
